var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"main-header navbar navbar-expand navbar-white navbar-light"},[_c('ul',{staticClass:"navbar-nav"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"id":"header-pushmenu","data-widget":"pushmenu","href":"#"}},[_c('i',{staticClass:"fas fa-bars"})])])]),_c('form',{staticClass:"form-inline ml-3"})])
}]

export { render, staticRenderFns }